import globalIP from '@/GlobelIP';
import axios from 'axios';
import { useEffect, useState } from 'react';

export default function useLabel() {
  const [attributesName, setAttributesName] = useState();
  useEffect(() => {
    const fetchData = async () => {
      const {
        data: { data }
      } = await axios.get(`${globalIP}/api/product-labels`);
      setAttributesName(data[0]['attributes']);
    };
    fetchData();
  }, []);
  return { attributesName };
}
